import dayjs from "dayjs";
import { auth } from "../constants/auth";
import _ from "lodash";
import { getV1PartiesId, postV1CurrencyInfo, postV1PartiesCheck, setBaseUrl } from "../api-client/api.accounting/api";
import { enqueueSnackbar } from "notistack";
import { fetchApi } from "./api";
import formatText from "./format-text";
import { formatDate, formatUtcDate } from "./dateFormat";
import { subModuleMappings, specificFilters } from './export-filters'
import parsePhoneNumberFromString from "libphonenumber-js";
import moment from 'moment-timezone'
import { getV1CrossHireRfqResponseItems, setBaseUrl as rentalSetBaseUrl } from "../api-client/api.rental/api";
import { getV1RfqResponseItems, setBaseUrl as purchaseSetBaseUrl } from "../api-client/api.purchase/api";
import { getV1AssemblyItemsId, postV1InventoryItemsCheck, setBaseUrl as inventorySetBaseUrl } from "../api-client/api.inventory/api";
import { getV1LocationsCountries, setBaseUrl as rbacSetBaseUrl } from "../api-client/api.rbac/api";
import { setBaseUrl as hrmsSetBaseUrl } from "../api-client/api.hrms/api";
import { postV1LeadCheck } from "../api-client/api.sales/api";
import { getApiConfig, onApiConfigReady } from "./api-config";
// import { postV1LeadCheck } from "../api-client/api.sales/api";
import { FieldDisableConfig, INVENTORY_ADD_MODE_DISABLED_FIELDS, INVENTORY_ALWAYS_DISABLED_FIELDS, INVENTORY_EDIT_MODE_DISABLED_FIELDS, INVENTORY_FIELDS_TO_BE_DISABLED, INVENTORY_MATERIAL_COSTING_TYPE_ARR, INVENTORY_MATERIAL_COSTING_TYPE_OPTIONS } from "./constant";

// Use onApiConfigReady to ensure setBaseUrl calls happen after API config is initialized
// This prevents module initialization order issues where common.ts might be imported
// before ERPUIProvider calls initializeApiConfig()
onApiConfigReady((config) => {
  const baseUrl = config.backendBaseUrl;
  setBaseUrl(`${baseUrl}/accounting`);
  inventorySetBaseUrl(`${baseUrl}/inventory`);
  rbacSetBaseUrl(`${baseUrl}/rbac`);
  rentalSetBaseUrl(`${baseUrl}/rental`);
  purchaseSetBaseUrl(`${baseUrl}/purchase`);
  hrmsSetBaseUrl(`${baseUrl}/hrms`);
});
export const isJsonParse = (jsonString?: string) => {
  if (!jsonString) return false;
  try {
    return JSON.parse(jsonString);
  } catch (err) {
    return false;
  }
};

export const generateRandomId = (concatString: string = "") => {
  const uniqueStringId = `${Date.now()}${concatString}${Math.random()}`.replace(
    ".",
    ""
  );
  const uniqueNumberId = Number(uniqueStringId.replace(concatString, ""));

  return { uniqueStringId, uniqueNumberId };
};

export const generateAndFormatStringFromObj = (
  obj: any = {},
  keysInOrder: string[] = []
) => {
  let string = "";

  keysInOrder?.forEach((key) => {
    if (obj?.[key]) {
      string = string ? string + ` ${obj?.[key]}` : obj?.[key];
    }
  });

  return string;
};

export const generateFields = (fieldsConfig: any) => {
  const defaultOperators = [
    { name: "null", label: "is null" },
    { name: "notNull", label: "is not null" },
  ];

  const textOperators = [
    { name: "contains", label: "contains" },
    { name: "beginsWith", label: "begins with" },
    { name: "endsWith", label: "ends with" },
    { name: "doesNotContain", label: "does not contain" },
    { name: "doesNotBeginWith", label: "does not begin with" },
    { name: "doesNotEndWith", label: "does not end with" },
    ...defaultOperators,
  ];

  const numberOperators = [
    { name: "=", label: "equal to" },
    { name: "<", label: "less than" },
    { name: "<=", label: "less than or equal to" },
    { name: ">", label: "greater than" },
    { name: ">=", label: "greater than or equal to" },
    ...defaultOperators,
  ];

  const selectOperators = [
    { name: "in", label: "in" },
    { name: "notIn", label: "not in" },
    ...defaultOperators,
  ];

  const dropdownOperators = [{ name: "in", label: "in" }];

  const dateOperators = [
    { name: "=", label: "on" },
    { name: "!=", label: "not on" },
    { name: "<", label: "before" },
    { name: "<=", label: "on or before" },
    { name: ">", label: "after" },
    { name: ">=", label: "on or after" },
    ...defaultOperators,
  ];

  const dateTimeOperators = [
    { name: "contains", label: "on" },
    { name: "notContain", label: "not on" },
    { name: "<", label: "before" },
    { name: "<=", label: "on or before" },
    { name: ">", label: "after" },
    { name: ">=", label: "on or after" },
    ...defaultOperators,

  ];

  // const booleanOperators = [{ name: "=", label: "is" }];

  const getFieldConfig = (field: any) => {

    let { type, values } = field;
    const { is_aggregate = false, table = null } = field;
    const { key: name, label, fieldType } = field;
    let operators, valueEditorType, inputType, datatype;

    if (field?.enum) {
      type = "select";

      let fieldArr = field.enum;

      if (
        fieldArr &&
        !Array.isArray(fieldArr) &&
        typeof fieldArr === "object"
      ) {
        fieldArr = Object.values(fieldArr);
      }

      values = fieldArr.map((value) => ({ name: value, label: value }));
    }

    if (fieldType === "select") {
      type = "select";

      values = field?.options;
    }

    if (field?.boolean) {
      type = "select";

      values = field?.values || [];
    }

    if (field?.table) {
      type = "table";
    }

    switch (type) {
      case "string":
        operators = textOperators;
        valueEditorType = "text";
        inputType = "text";
        break;
      case "number":
        operators = numberOperators;
        valueEditorType = "text";
        inputType = "number";
        break;
      case "select":
        operators = selectOperators;
        valueEditorType = "select";
        inputType = "select";
        break;
      case "table":
        operators = dropdownOperators;
        valueEditorType = "select";
        inputType = "select";
        break;
      case "datetime":
        operators = dateTimeOperators;
        valueEditorType = "text";
        inputType = "date";
        datatype = "date";
        break;
      case "date":
        operators = dateOperators;
        valueEditorType = "text";
        inputType = "date";
        datatype = "date";
        break;
      case "boolean":
        operators = [...dropdownOperators, ...defaultOperators];
        valueEditorType = "select";
        inputType = "select";
        break;
      default:
        operators = textOperators;
        valueEditorType = "text";
        inputType = "text";
    }

    return {
      name: name.replace("__replaceKey", ''),
      // name,
      label,
      valueEditorType,
      operators,
      inputType,
      datatype,
      comparator: "datatype",
      values,
      is_aggregate,
      table,
    };
  };

  return fieldsConfig.filter((f: any) => f.isFilterAllowed && f?.type).map(getFieldConfig);
};

export const generateQueryString = (rule: any) => {
  const operatorMap = {
    null: "eq",
    notNull: "ne",
    contains: "like",
    beginsWith: "like",
    endsWith: "like",
    doesNotContain: "ne",
    notContain: "notLike",
    doesNotBeginWith: "ne",
    doesNotEndWith: "ne",
    "<": "lt",
    "<=": "lte",
    ">": "gt",
    ">=": "gte",
    "=": "eq",
    "!=": "ne",
    in: "in",
    notIn: "nin",
  };

  const formatValue = (operator: any, value: any) => {
    if (["in", "notIn"].includes(operator)) {
      return `[${value}]`;
    } else if (["like", "ilike", "notLike"].includes(operator)) {
      if (operator === "beginsWith") return `${value}%`;
      if (operator === "endsWith") return `%${value}`;
      return `%${value}%`;
    } else if (operator === "null" || operator === "notNull") {
      return "";
    } else {
      return value;
    }
  };

  const processRules = (rules: any) => {
    return rules.map((rule) => {
      let ruleValue = rule.value;
      if (Array.isArray(ruleValue)) {
        ruleValue = ruleValue.map(rv => {
          if (typeof rv === 'object') {
            rv = rv.name
          }
          return rv
        })
      }
      if (rule.rules) {

        const combinator = rule.combinator === "or" ? "|" : "&";
        const nestedRules = processRules(rule.rules);
        return `${nestedRules.join(combinator)}`;
      } else {
        let operator = operatorMap[rule.operator];

        if (
          (operator === "in" || operator === "notIn") &&
          typeof ruleValue === "string"
        ) {
          operator = "eq";
        }

        if (rule.operator === "null" || rule.operator === "notNull") {
          ruleValue = null;
        }

        const value = formatValue(operator, ruleValue);
        if (operator === "eq" || operator === "ne") {
          return `${rule.field}.${operator}=${value}`;
        }
        return `${rule.field}.${operator}=${value}`;
      }
    });
  };

  if (!rule || !rule.rules || rule.rules.length === 0) return "";
  const combinator = rule.combinator === "or" ? "|" : "&";
  const processedRules = processRules(rule.rules);
  return `(${processedRules.join(combinator)})`.replace(/ /g, "---");
};


// export const formatAmount = (
// 	amount: number | string = '',
// 	format: string = '',
// 	position: 'after' | 'before' = 'after',
// 	symbol?: string
// ) => {

// 	let isNegative = false;
// 	amount = amount.toString();
// 	if (amount.includes('-')) {
// 		amount = amount.replace('-', '');
// 		isNegative = true;
// 	}

// 	if (format && amount) {
// 		// Split the format into integer and decimal parts
// 		const [integerFormat, decFormat] = format.split('.');
// 		let intFormat: string | string[] = integerFormat;
// 		// Convert amount to string and split into integer and decimal parts
// 		const [integerAmount, decAmount] = Math.abs(Number(amount))
// 			.toFixed(decFormat ? decFormat.length : 0)
// 			.toString()
// 			.trim()
// 			.split('.');
// 		let intAmount: string | string[] = integerAmount;
// 		// let [intAmount, decAmount] = Math.abs(amount).toFixed(decFormat ? decFormat.length : 0).split('.');

// 		const am = intAmount.split('').reverse().join('');
// 		const formatArr: string[] = intFormat.split(',').reverse();

// 		if (intFormat.length !== 1) {
// 			while (formatArr.join('').length < am.length) {
// 				if (formatArr.length >= 2) {
// 					formatArr.splice(1, 0, formatArr[1]);
// 				} else {
// 					formatArr.push(formatArr[formatArr.length - 1]);
// 				}
// 			}
// 		} else {
// 			const formatZeroIndex = am?.split('')?.reduce((lv: string) => {
// 				return lv + '#';
// 			}, '');

// 			formatArr[0] = formatZeroIndex;
// 		}

// 		intFormat = formatArr.join(',').split('');

// 		// Reverse the integer amount and format for easier processing from right to left
// 		intAmount = intAmount.split('').reverse();

// 		let formattedInt = '';
// 		let intIndex = 0;
// 		for (let i = 0; i < intFormat.length; i++) {
// 			if (intFormat[i] === '#') {
// 				formattedInt +=
// 					intAmount[intIndex] !== undefined ? intAmount[intIndex++] : '';
// 			} else if (intFormat[i] === ',') {
// 				formattedInt += intIndex > 0 ? ',' : '';
// 			} else {
// 				formattedInt += intFormat[i];
// 			}
// 		}

// 		// Reverse back to the original order
// 		formattedInt = formattedInt.split('').reverse().join('');

// 		// Handle the decimal part
// 		let formattedDec = '';
// 		if (decFormat && decAmount) {
// 			for (let i = 0; i < decFormat.length; i++) {
// 				formattedDec +=
// 					decFormat[i] === '#'
// 						? decAmount[i] !== undefined
// 							? decAmount[i]
// 							: ''
// 						: decFormat[i];
// 			}
// 		}

// 		while (formattedInt?.startsWith(',')) {
// 			formattedInt = formattedInt.replace(',', '');
// 		}

// 		// Combine integer and decimal parts
// 		let formattedAmount = formattedInt;
// 		if (formattedDec) {
// 			formattedAmount += '.' + formattedDec;
// 		}

// 		// Add negative sign if the amount is negative
// 		if (isNegative) {
// 			formattedAmount = '-' + formattedAmount;
// 		}

// 		// Add symbol on specific position
// 		if (symbol && position) {

// 			if (position === 'after') {
// 				formattedAmount = formattedAmount + ' ' + symbol;
// 			} else if (position === 'before') {
// 				formattedAmount = symbol + ' ' + formattedAmount;
// 			}
// 		}
// 		return formattedAmount;
// 	}

// 	return isNegative ? '-' + amount : amount;
// };


export const getOperatorLabel = (rule: any, filterFields: any[]) => {
  const defaultOperators = [
    { name: 'null', label: 'Is null' },
    { name: 'notNull', label: 'Is not null' }
  ];

  const textOperators = [
    { name: 'contains', label: 'Contains' },
    { name: 'beginsWith', label: 'Begins with' },
    { name: 'endsWith', label: 'Ends with' },
    { name: 'doesNotContain', label: 'Does not contain' },
    { name: 'doesNotBeginWith', label: 'Does not begin with' },
    { name: 'doesNotEndWith', label: 'Does not end with' },
    ...defaultOperators
  ];

  const numberOperators = [
    { name: '=', label: 'Equal to' },
    { name: '<', label: 'Less than' },
    { name: '<=', label: 'Less than or equal to' },
    { name: '>', label: 'Greater than' },
    { name: '>=', label: 'Greater than or equal to' },
    ...defaultOperators
  ];

  const selectOperators = [
    { name: 'in', label: 'In' },
    { name: 'notIn', label: 'Not in' },
    ...defaultOperators
  ];

  const dropdownOperators = [{ name: 'in', label: 'In' }];

  const dateOperators = [
    { name: '=', label: 'On' },
    { name: '!=', label: 'Not on' },
    { name: '<', label: 'Before' },
    { name: '<=', label: 'On or before' },
    { name: '>', label: 'After' },
    { name: '>=', label: 'On or after' },
    ...defaultOperators
  ];

  const booleanOperators = [{ name: '=', label: 'is' }, ...defaultOperators];
  const { field: rField, operator } = rule;
  const field = filterFields?.find(
    (ff) => ff.key.replace('__replaceKey', '') == rField
  );
  let operatorLable = '';
  if (field) {
    let { type } = field || {};
    // const { is_aggregate = false, table = null } = field || {};
    const { fieldType } = field;

    if (field?.enum) {
      type = 'select';
    }

    if (fieldType === 'select') {
      type = 'select';
    }

    if (field?.boolean) {
      type = 'select';
    }

    if (field?.table) {
      type = 'table';
    }

    switch (type) {
      case 'string':
        operatorLable =
          textOperators.find((to) => to.name == operator)?.label || '';
        break;
      case 'number':
        operatorLable =
          numberOperators.find((no) => no.name == operator)?.label || '';
        break;
      case 'select':
        operatorLable =
          selectOperators.find((so) => so.name == operator)?.label || '';
        break;
      case 'table':
        operatorLable =
          dropdownOperators.find((dwo) => dwo.name == operator)?.label || '';
        break;
      case 'datetime':
        operatorLable =
          dateOperators.find((dto) => dto.name == operator)?.label || '';
        break;
      case 'date':
        operatorLable =
          dateOperators.find((dto) => dto.name == operator)?.label || '';
        break;
      case 'boolean':
        operatorLable =
          booleanOperators.find((bo) => bo.name == operator)?.label || '';
        break;
    }
  }

  return operatorLable;
};

export const formatAmount = (
  amount: number | string = "",
  format: string = "",
  position: "after" | "before" = "before",
  symbol?: string,
  fraction?: number
): string => {
  if (amount === "" || amount === null || amount === undefined) {
    amount = 0;
  }

  if (typeof amount === "string") {
    amount = parseFloat(amount.replace(/[^\d.-]/g, ""));
    if (isNaN(amount)) return "";
  }

  const f = fraction ?? getDefaultFraction();
  const num = parseFloat((amount as number).toFixed(f));

  let formatter: Intl.NumberFormat;

  switch (format) {
    case "#,###.##":
      formatter = new Intl.NumberFormat("en-US", {
        minimumFractionDigits: f,
        maximumFractionDigits: f,
      });
      break;
    case "#.###,##":
      formatter = new Intl.NumberFormat("de-DE", {
        minimumFractionDigits: f,
        maximumFractionDigits: f,
      });
      break;
    case "# ###.##":
      formatter = new Intl.NumberFormat("fr-FR", {
        minimumFractionDigits: f,
        maximumFractionDigits: f,
      });
      break;
    case "# ###,##":
      formatter = new Intl.NumberFormat("es-ES", {
        minimumFractionDigits: f,
        maximumFractionDigits: f,
      });
      break;
    case "#’ ###. ##":
      formatter = new Intl.NumberFormat("de-CH", {
        minimumFractionDigits: f,
        maximumFractionDigits: f,
      });
      break;
    case "#, ###.##":
      formatter = new Intl.NumberFormat("en-GB", {
        minimumFractionDigits: f,
        maximumFractionDigits: f,
      });
      break;
    default:
      formatter = new Intl.NumberFormat("en-US", {
        minimumFractionDigits: f,
        maximumFractionDigits: f,
      });
  }

  let formattedAmount = formatter.format(num);

  // Handle specific spacing for formats
  if (format === "# ###.##" || format === "# ###,##") {
    formattedAmount = formattedAmount.replace(/\u00A0/g, " ");
  }
  if (format === "#’ ###. ##") {
    formattedAmount = formattedAmount.replace(/\u00A0/g, " ").replace(/'/g, "’");
  }
  if (format === "#, ###.##") {
    formattedAmount = formattedAmount.replace(/,/g, ", ");
  }

  if (symbol) {
    return position === "after"
      ? `${formattedAmount} ${symbol}`
      : `${symbol} ${formattedAmount}`;
  }

  return formattedAmount;
};


export const filterCoaByCompanyIdOrNull = (
  allCoa: any[],
  { companyId }: { companyId?: number | string | null | any[] }
) => {
  if (!allCoa?.length) return [];

  return allCoa.filter((coa) => {
    if (companyId) {
      const ic = Array.isArray(companyId)
        ? companyId.map(Number)
        : [Number(companyId)];
      return !coa.company_ids || coa.company_ids.some((c) => ic.includes(c.id));
    }
    return !coa.company_ids;
  });
};

// type DiscountDueDateBasedOn = "DAYS_AFTER_INVOICE_DATE" | "DAYS_AFTER_INVOICE_MONTH" | "MONTHS_AFTER_INVOICE_MONTH";

export const validateDiscountValidity = (
  date,
  discountDueDateBasedOn,
  discountValidity
) => {
  const currentDate = new Date();
  const dateObj = new Date(date);
  let discountEndDate;

  switch (discountDueDateBasedOn) {
    case "DAYS_AFTER_INVOICE_DATE":
      discountEndDate = new Date(dateObj);
      discountEndDate.setDate(
        discountEndDate.getDate() + parseInt(discountValidity)
      );
      break;
    case "DAYS_AFTER_INVOICE_MONTH":
      discountEndDate = new Date(
        dateObj.getFullYear(),
        dateObj.getMonth() + 1,
        parseInt(discountValidity)
      );
      break;
    case "MONTHS_AFTER_INVOICE_MONTH":
      discountEndDate = new Date(dateObj);
      discountEndDate.setMonth(
        discountEndDate.getMonth() + parseInt(discountValidity)
      );
      discountEndDate = new Date(
        discountEndDate.getFullYear(),
        discountEndDate.getMonth() + 1,
        0
      ); // End of the month
      break;
    default:
      throw new Error("Invalid discount_due_date_based_on value");
  }

  return currentDate <= discountEndDate;
};

const token = localStorage.getItem(auth.storageTokenKeyName) || undefined;
export const postImportSheet = async (request: any, moduleName: string) => {

  let mainModule = window.location.pathname.split('/')[2]
  const subModuleName = window.location.pathname.split('/')[3]
  let type = ''
  if (mainModule == "crm") {
    mainModule = "sales"
  }
  if (mainModule == "procurement") {
    mainModule = "purchase"
  }
  if (mainModule == 'rental' && subModuleName == 'item') {
    mainModule = 'inventory'
  }
  if (mainModule == 'rental' && moduleName == 'quotation') {
    moduleName = 'rental-quotations'
  }
  if (mainModule == 'rental' && moduleName == 'lead') {
    moduleName = 'rental-lead'
  }
  if (mainModule == 'rental' && moduleName == 'rfq') {
    mainModule = 'purchase'
  }
  if (mainModule == 'rental' && moduleName == 'purchase-orders') {
    mainModule = 'purchase'
  }
  if (mainModule == 'rental' && moduleName == 'opportunity') {
    moduleName = 'rental-opportunity'
  }

  if (moduleName == 'collection-entries') {
    moduleName = 'payment-entries'
    type = 'receive'
  }



  const baseUrl = `${getApiConfig().backendBaseUrl}/${mainModule}`;

  const headers = {};

  headers["x-token"] = token;
  // headers['Content-type'] = 'application/json; charset=utf-8';

  const response = await fetch(`${baseUrl}/v1/${moduleName}/import${type ? `?type=${type}` : ''}`, {
    method: "POST",
    body: request,
    headers,
  });

  if (!response.ok) {
    throw new Error(await response.text());
  }

  return await response.json();
};

export const getExcelTemplateGenerateTemplate = async (request: any) => {
  const baseUrl = `${getApiConfig().backendBaseUrl}/accounting`;

  const headers = {};

  if (request["x-token"] !== undefined) {
    headers["x-token"] = request["x-token"];
    delete request["x-token"];
  }
  if (request["Content-Type"] !== undefined) {
    headers["Content-Type"] = request["Content-Type"];
    delete request["Content-Type"];
  }
  const response = await fetch(
    `${baseUrl}/v1/excel-template/generate-template?resource=${request.resource.toString()}`,
    {
      headers,
    }
  );

  if (!response.ok) {
    throw new Error(await response.text());
  }

  return await response;
};

const mergeBaseFilter = (base: string, existing: string): string => {
  const clean = (s: string) => (s || '').replace(/^\(|\)$/g, '');
  const userFilter = existing && existing !== '()' ? clean(existing) : '';
  return userFilter ? `(${base}&${userFilter})` : `(${base})`;
};

export const getExcelExportTemplate = async (request: any) => {
  const baseUrl = `${getApiConfig().backendBaseUrl}`;

  const headers = {};

  if (request["x-token"] !== undefined) {
    headers["x-token"] = request["x-token"];
    delete request["x-token"];
  }
  if (request["Content-Type"] !== undefined) {
    headers["Content-Type"] = request["Content-Type"];
    delete request["Content-Type"];
  }
  const pathParts = window.location.pathname.split("/");
  const currentPath = pathParts.pop();
  const currentModule = pathParts[3];
  let moduleName = pathParts[2];
  if (currentPath == "demand-planning") {
    moduleName = "purchase"
  }
  if (moduleName == "crm") {
    moduleName = "sales"
  }
  if (moduleName == "procurement") {
    moduleName = "purchase"
  }
  let combinedFilters = "";
  const excelpath = "generate-excel";
  if (currentPath && specificFilters[currentPath]) {
    combinedFilters = specificFilters[currentPath];
  }
  if (currentPath === "items" || currentPath === 'item') {
    if (request?.title && request?.title == "Non Inventory") {
      request.title = "non-inventory"
    } else if (request?.title && request?.title == "Assembly (Finished product)") {
      request.title = "assembly"
    }
    combinedFilters += `&type.eq=${request?.title.toLowerCase()}`
  }
  if (request.filterQueryString) {
    const cleanedFilterQueryString = request.filterQueryString.replace(/[{}()]/g, "");
    if (combinedFilters) {
      combinedFilters = `(${combinedFilters}&${cleanedFilterQueryString})`;
    } else {
      combinedFilters = `(${cleanedFilterQueryString})`;
    }
  } else {
    combinedFilters = `(${combinedFilters})`;
  }
  if (combinedFilters === "()") {
    combinedFilters = "";
  }
  if (combinedFilters.includes("is_variant.eq=false|self_variant.eq=true")) {
    if (moduleName == "rental") {
      combinedFilters = combinedFilters.replace("is_variant.eq=false|self_variant.eq=true", "(is_variant.eq=false|self_variant.eq=true&is_rental.eq=1)");
    } else {
      combinedFilters = combinedFilters.replace("is_variant.eq=false|self_variant.eq=true", "(is_variant.eq=false|self_variant.eq=true)");
    }
  }



  if (currentPath && !specificFilters[currentPath] && !request.filterQueryString) {
    combinedFilters = ""
  }

  let subModuleName = subModuleMappings[currentPath || ""] || currentPath;
  if (moduleName == "sales" && subModuleName == "quotation") {
    combinedFilters = mergeBaseFilter('is_rental.eq=0', combinedFilters)
  }
  if (moduleName == "sales" && subModuleName == "sales-orders") {
    combinedFilters = mergeBaseFilter('is_rental.eq=0', combinedFilters)
  }
  if (moduleName == "rental" && subModuleName == "rental-lead") {
    combinedFilters = mergeBaseFilter('is_rental.eq=1', combinedFilters)
  }
  if (moduleName == "sales" && subModuleName == "lead") {
    combinedFilters = mergeBaseFilter('is_rental.eq=0', combinedFilters)
  }
  if (moduleName == "sales" && subModuleName == "opportunity") {
    combinedFilters = mergeBaseFilter('is_rental.eq=0', combinedFilters)
  }

  if (
    moduleName === "purchase" &&
    (subModuleName === "purchase-requests" || subModuleName === "rfq" || subModuleName === "purchase-orders")
  ) {
    combinedFilters = mergeBaseFilter('is_rental.eq=0', combinedFilters);
  }

  if (moduleName == "rental" && subModuleName == "quotation") {
    subModuleName = "rental-quotations"
  }
  if (moduleName == "rental" && subModuleName == "opportunity") {
    subModuleName = "rental-opportunity"
    combinedFilters = mergeBaseFilter('is_rental.eq=1', combinedFilters)
  }
  if (moduleName == 'rental' && subModuleName == 'item') {
    moduleName = "inventory"
    subModuleName = 'inventory-items'
  }
  if (moduleName == 'rental' && subModuleName == 'category') {
    moduleName = "inventory"
    subModuleName = 'category-items'
  }
  if (moduleName == 'rental' && subModuleName == 'purchase-requests') {
    subModuleName = 'cross-hire-requests'
    combinedFilters = '(is_rental.eq=1)'
  }
  if (moduleName == 'rental' && subModuleName == 'rfq' && currentModule != 'purchase') {
    subModuleName = 'cross-hire-rfq'
    combinedFilters = '(is_rental.eq=1)'
  }
  if (moduleName == 'rental' && subModuleName == 'rfq' && currentModule == 'purchase') {
    moduleName = 'purchase'
    combinedFilters = '(is_rental.eq=0)'
  }

  if (moduleName == 'rental' && subModuleName == 'orders' && request.title !== 'Rental Orders' && request.title !== 'Replacement Orders') {
    subModuleName = 'cross-hire-orders'
    combinedFilters = mergeBaseFilter('is_rental.eq=1', combinedFilters)
  }
  if (moduleName == 'rental' && (subModuleName == 'orders' || subModuleName == 'cross-hire-orders') && currentModule == 'purchase') {
    moduleName = 'purchase'
    subModuleName = "purchase-orders"
    combinedFilters = '(is_rental.eq=0)'
  }
  if (moduleName == 'rental' && subModuleName == 'rental-quotations' && request.title == "Quotations") {
    combinedFilters = mergeBaseFilter('is_visible.eq=1&is_rental.eq=1&is_replacement.eq=0', combinedFilters)
  }
  if (moduleName == 'rental' && subModuleName == 'rental-quotations' && request.title == "Replacement Quotations") {
    combinedFilters = mergeBaseFilter('is_visible.eq=1&is_rental.eq=1&is_replacement.eq=1', combinedFilters)
  }
  if (moduleName == 'rental' && subModuleName == 'orders' && request.title == 'Rental Orders') {
    subModuleName = 'rental-orders'
    combinedFilters = mergeBaseFilter('is_rental.eq=1&is_replacement.eq=0', combinedFilters)
  }
  if (moduleName == 'rental' && subModuleName == 'orders' && request.title == 'Replacement Orders') {
    subModuleName = 'rental-orders'
    combinedFilters = mergeBaseFilter('is_rental.eq=1&is_replacement.eq=1', combinedFilters)
  }
  const queryParams: Record<string, string> = {};
  if (request.selectedIds && combinedFilters) {
    if (request.selectedIds.length > 0) {
      combinedFilters = `(${combinedFilters}&id.in=${request.selectedIds})`;
    }
  } else if (request.selectedIds) {
    if (request.selectedIds.length > 0) {
      combinedFilters = `(id.in=${request.selectedIds})`;
    }
  }
  if (combinedFilters) {
    queryParams.filters = combinedFilters;
  }
  
  // Extract visible columns from activePage - filter only visible ones and get their keys and labels
  if (request.activePage?.visible_columns && request.activePage.visible_columns.length > 0 && request.columns) {
    const visibleColumns = request.columns
      .filter((col: any) => col.visible !== false)
      .map((col: any) => {
        return {
          key: col.accessorKey || col.key,
          label: col.header
        };
      })
      .filter((col: any) => col.key);

    if (visibleColumns.length > 0) {
      queryParams.columns = JSON.stringify(visibleColumns);
    }
  }
  const queryString = new URLSearchParams(queryParams).toString();
  const response = await fetch(
    `${baseUrl}/${moduleName}/v1/${subModuleName}/${excelpath}${queryString ? `?${queryString}` : ""
    }`,
    {
      headers,
    }
  );

  if (!response.ok) {
    throw new Error(await response.text());
  }

  return await response;
};

export const getPdfExportTemplate = async (request: any) => {
  const baseUrl = `${getApiConfig().backendBaseUrl}`;
  const headers = {};

  if (request["x-token"] !== undefined) {
    headers["x-token"] = request["x-token"];
    delete request["x-token"];
  }
  if (request["Content-Type"] !== undefined) {
    headers["Content-Type"] = request["Content-Type"];
    delete request["Content-Type"];
  }
  const pathParts = window.location.pathname.split("/");
  const currentPath = pathParts.pop();
  const currentModule = pathParts[3];
  let moduleName = pathParts[2];

  if (currentPath == "demand-planning") {
    moduleName = "purchase"
  }
  if (moduleName == "crm") {
    moduleName = "sales"
  }
  if (moduleName == "procurement") {
    moduleName = "purchase"
  }
  let combinedFilters = "";
  const pdfpath = "generate-pdf";
  if (currentPath && specificFilters[currentPath]) {
    combinedFilters = specificFilters[currentPath];
  }
  if (currentPath === "items" || currentPath === 'item') {
    if (request?.title && request?.title == "Non Inventory") {
      request.title = "non-inventory"
    } else if (request?.title && request?.title == "Assembly (Finished product)") {
      request.title = "assembly"
    }
    combinedFilters += `&type.eq=${request?.title.toLowerCase()}`
  }
  if (request.filterQueryString) {
    const cleanedFilterQueryString = request.filterQueryString.replace(/[{}()]/g, "");
    if (combinedFilters) {
      combinedFilters = `(${combinedFilters}&${cleanedFilterQueryString})`;
    } else {
      combinedFilters = `(${cleanedFilterQueryString})`;
    }
  } else {
    combinedFilters = `(${combinedFilters})`;
  }
  if (combinedFilters === "()") {
    combinedFilters = "";
  }
  if (combinedFilters.includes("is_variant.eq=false|self_variant.eq=true")) {
    if (moduleName == "rental") {
      combinedFilters = combinedFilters.replace("is_variant.eq=false|self_variant.eq=true", "(is_variant.eq=false|self_variant.eq=true&is_rental.eq=1)");
    } else {
      combinedFilters = combinedFilters.replace("is_variant.eq=false|self_variant.eq=true", "(is_variant.eq=false|self_variant.eq=true)");
    }
  }

  if (currentPath && !specificFilters[currentPath] && !request.filterQueryString) {
    combinedFilters = ""
  }

  let subModuleName = subModuleMappings[currentPath || ""] || currentPath;

  if (moduleName == "sales" && subModuleName == "quotation") {
    combinedFilters = mergeBaseFilter('is_rental.eq=0', combinedFilters)
  }
  if (moduleName == "sales" && subModuleName == "sales-orders") {
    combinedFilters = mergeBaseFilter('is_rental.eq=0', combinedFilters)
  }
  if (moduleName == "rental" && subModuleName == "rental-lead") {
    combinedFilters = mergeBaseFilter('is_rental.eq=1', combinedFilters)
  }
  if (moduleName == "sales" && subModuleName == "lead") {
    combinedFilters = mergeBaseFilter('is_rental.eq=0', combinedFilters)
  }
  if (moduleName == "sales" && subModuleName == "opportunity") {
    combinedFilters = mergeBaseFilter('is_rental.eq=0', combinedFilters)
  }

  if (
    moduleName === "purchase" &&
    (subModuleName === "purchase-requests" || subModuleName === "rfq" || subModuleName === "purchase-orders")
  ) {
    combinedFilters = mergeBaseFilter('is_rental.eq=0', combinedFilters);
  }

  if (moduleName == "rental" && subModuleName == "quotation") {
    subModuleName = "rental-quotations"
  }
  if (moduleName == "rental" && subModuleName == "opportunity") {
    subModuleName = "rental-opportunity"
    combinedFilters = mergeBaseFilter('is_rental.eq=1', combinedFilters)
  }
  if (moduleName == 'rental' && subModuleName == 'item') {
    moduleName = "inventory"
    subModuleName = 'inventory-items'
  }
  if (moduleName == 'rental' && subModuleName == 'category') {
    moduleName = "inventory"
    subModuleName = 'category-items'
  }
  if (moduleName == 'rental' && subModuleName == 'purchase-requests') {
    subModuleName = 'cross-hire-requests'
    combinedFilters = '(is_rental.eq=1)'
  }
  if (moduleName == 'rental' && subModuleName == 'rfq' && currentModule != 'purchase') {
    subModuleName = 'cross-hire-rfq'
    combinedFilters = '(is_rental.eq=1)'
  }
  if (moduleName == 'rental' && subModuleName == 'rfq' && currentModule == 'purchase') {
    moduleName = 'purchase'
    combinedFilters = '(is_rental.eq=0)'
  }

  if (moduleName == 'rental' && subModuleName == 'orders' && request.title !== 'Rental Orders' && request.title !== 'Replacement Orders') {
    subModuleName = 'cross-hire-orders'
    combinedFilters = mergeBaseFilter('is_rental.eq=1', combinedFilters)
  }
  if (moduleName == 'rental' && (subModuleName == 'orders' || subModuleName == 'cross-hire-orders') && currentModule == 'purchase') {
    moduleName = 'purchase'
    subModuleName = "purchase-orders"
    combinedFilters = '(is_rental.eq=0)'
  }
  if (moduleName == 'rental' && subModuleName == 'rental-quotations' && request.title == "Quotations") {
    combinedFilters = mergeBaseFilter('is_visible.eq=1&is_rental.eq=1&is_replacement.eq=0', combinedFilters)
  }
  if (moduleName == 'rental' && subModuleName == 'rental-quotations' && request.title == "Replacement Quotations") {
    combinedFilters = mergeBaseFilter('is_visible.eq=1&is_rental.eq=1&is_replacement.eq=1', combinedFilters)
  }
  if (moduleName == 'rental' && subModuleName == 'orders' && request.title == 'Rental Orders') {
    subModuleName = 'rental-orders'
    combinedFilters = mergeBaseFilter('is_rental.eq=1&is_replacement.eq=0', combinedFilters)
  }
  if (moduleName == 'rental' && subModuleName == 'orders' && request.title == 'Replacement Orders') {
    subModuleName = 'rental-orders'
    combinedFilters = mergeBaseFilter('is_rental.eq=1&is_replacement.eq=1', combinedFilters)
  }

  const queryParams: Record<string, string> = {};

  // Handle selected rows - send as separate parameter instead of adding to filters
  if (request.selectedIds && request.selectedIds.length > 0) {
    // Extract IDs - handle both array of IDs and array of objects
    let rowIds: string[] = [];
    if (Array.isArray(request.selectedIds)) {
      rowIds = request.selectedIds.map((item: any) => {
        // If item is an object with 'id' property, extract it
        if (typeof item === 'object' && item !== null && 'id' in item) {
          return String(item.id);
        }
        // Otherwise, convert directly to string
        return String(item);
      }).filter((id: string) => id && id !== 'undefined' && id !== 'null');
    } else {
      rowIds = [String(request.selectedIds)];
    }

    if (rowIds.length > 0) {
      queryParams.selectedRows = rowIds.join(',');
      console.log("Sending selectedRows:", queryParams.selectedRows);
    }
  }

  // Extract visible columns from activePage - filter only visible ones and get their keys and labels
  if (request.activePage?.visible_columns && request.activePage.visible_columns.length > 0) {
    const visibleColumns = request.columns
      .filter((col: any) => col.visible !== false)
      .map((col: any) => {
        return {
          key: col.accessorKey || col.key,
          label: col.header
        };
      })
      .filter((col: any) => col.key);

    if (visibleColumns.length > 0) {
      queryParams.columns = JSON.stringify(visibleColumns);
    }
  }

  // Extract sort/order from activePage to maintain display order in PDF
  if (request.activePage?.sort) {
    const hasSort = Array.isArray(request.activePage.sort)
      ? request.activePage.sort.length > 0
      : Object.keys(request.activePage.sort).length > 0;

    if (hasSort) {
      let orderObject = {};

      if (Array.isArray(request.activePage.sort) && request.activePage.sort.length > 0) {
        // MRT array format: [{ id: 'column', desc: false }]
        const sortItem = request.activePage.sort[0];
        orderObject[sortItem.id] = sortItem.desc ? 'desc' : 'asc';
      } else if (typeof request.activePage.sort === 'object') {
        if (request.activePage.sort.id !== undefined && request.activePage.sort.desc !== undefined) {
          // Single sort object: { id: 'column', desc: true }
          orderObject[request.activePage.sort.id] = request.activePage.sort.desc ? 'desc' : 'asc';
        } else {
          // Already in backend format: { column: 'asc' }
          orderObject = request.activePage.sort;
        }
      }

      queryParams.order = JSON.stringify(orderObject);
    }
  }

  if (combinedFilters) {
    queryParams.filters = combinedFilters;
  }
  const queryString = new URLSearchParams(queryParams).toString();
  const response = await fetch(
    `${baseUrl}/${moduleName}/v1/${subModuleName}/${pdfpath}${queryString ? `?${queryString}` : ""
    }`,
    {
      headers,
    }
  );

  if (!response.ok) {
    throw new Error(await response.text());
  }

  return await response;
};

export const removeIdStaticIdsFromMongoObject = (data: any) => {
  const newData = data.map((ele: { _id: string | number }) => {
    if (typeof ele._id === "number") {
      return { ...ele, _id: null };
    }
    return ele;
  });

  return newData;
};

/**
 * * FILE UPLOAD
 */
const spliceUploadedLocation = (uploadedlocation: string) => {
  const splitLocation = uploadedlocation.split("/");
  if (splitLocation.length) {
    splitLocation.splice(0, splitLocation.length - 2);
    return splitLocation.join("/");
  }

  return uploadedlocation;
};

/**
 * Fetch with retry logic for network resilience
 */
async function fetchWithRetry(
  url: string,
  options: RequestInit,
  maxRetries: number,
  retryDelay: number
): Promise<Response> {
  let lastError: Error;

  for (let attempt = 0; attempt <= maxRetries; attempt++) {
    try {
      const response = await fetch(url, options);

      // If it's a server error (5xx), retry
      if (response.status >= 500 && attempt < maxRetries) {
        throw new Error(`Server error: ${response.status} ${response.statusText}`);
      }

      return response;
    } catch (error: any) {
      lastError = error;

      // Don't retry for abort signals or client errors (4xx)
      if (error.name === 'AbortError') {
        throw error;
      }

      if (attempt < maxRetries) {
        const delay = retryDelay * Math.pow(2, attempt); // Exponential backoff
        console.warn(`Attempt ${attempt + 1} failed, retrying in ${delay}ms...`, error.message);
        await new Promise(resolve => setTimeout(resolve, delay));
      }
    }
  }

  throw lastError!;
}

/**
 * Helper function to format file size in human-readable format
 */
function formatFileSize(bytes: number): string {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
}

// Interface declarations moved to exported section below
export interface UploadOptions {
  onProgress?: (progress: ProgressInfo) => void;
  chunkSize?: number;
  retryAttempts?: number;
  retryDelay?: number;
}

export interface ProgressInfo {
  fileName: string;
  progress: number;
  bytesUploaded: number;
  totalBytes: number;
  fileIndex?: number;
  totalFiles?: number;
}

export interface FileUploadResponse {
  data: {
    preSignedData: {
      uploadId: string;
      fileName: string;
      preSignedUrls: Array<{
        partNumber: number;
        presignedUrl: string;
      }>;
      location?: string;
      presignedUrl?: string; // For single part uploads
    };
  };
}

export interface CompleteUploadResponse {
  data: {
    location: string;
  };
}

export interface UploadPart {
  partNumber: number;
  etag: string;
}

export const handleRegularUpload = async (
  files: File[],
  controller: AbortController,
  module: string,
  options: UploadOptions = {}
): Promise<string[]> => {
  const BASE_URL = `${getApiConfig().backendBaseUrl}/${module}/v1/file-upload/`;
  const COMPLETE_BASE_URL = `${getApiConfig().backendBaseUrl}/${module}/v1/file-upload/mark-complete`;
  const authToken = localStorage.getItem(auth.storageTokenKeyName);

  const {
    onProgress,
    chunkSize = 5 * 1024 * 1024, // 5MB default chunk size (S3 minimum for multipart)
    retryAttempts = 3,
    retryDelay = 1000
  } = options;

  if (!authToken) {
    throw new Error('Authentication token not found. Please log in again.');
  }

  // Validate chunk size for multipart uploads
  // if (chunkSize < 1024 * 1024) {
  //   console.warn('Chunk size less than 5MB may cause issues with S3 multipart uploads');
  // }

  try {
    const uploaded: string[] = [];

    // Process files sequentially to maintain order and avoid overwhelming the server
    for (let fileIndex = 0; fileIndex < files.length; fileIndex++) {
      const file = files[fileIndex];

      if (controller.signal.aborted) {
        throw new Error('Upload cancelled by user');
      }

      try {
        const uploadedLocation = await uploadSingleFile(
          file,
          fileIndex,
          files.length,
          controller,
          BASE_URL,
          COMPLETE_BASE_URL,
          authToken,
          chunkSize,
          retryAttempts,
          retryDelay,
          onProgress
        );

        uploaded.push(uploadedLocation);

      } catch (fileError: any) {
        console.error(`❌ Failed to upload ${file.name}:`, fileError.message);
        throw new Error(`Failed to upload ${file.name}: ${fileError.message}`);
      }
    }

    return uploaded;
  } catch (error: any) {
    console.error('❌ Upload process failed:', error.message);
    throw new Error(error.message || 'Upload failed');
  }
};

const uploadSingleFile = async (
  file: File,
  fileIndex: number,
  totalFiles: number,
  controller: AbortController,
  baseUrl: string,
  completeUrl: string,
  authToken: string,
  chunkSize: number,
  retryAttempts: number,
  retryDelay: number,
  onProgress?: (progress: ProgressInfo) => void
): Promise<string> => {
  const isMultipart = file.size > chunkSize;
  const totalParts = isMultipart ? Math.ceil(file.size / chunkSize) : 1;

  const preSignedResponse = await fetchWithRetry(
    `${baseUrl}?key=${encodeURIComponent(file.name)}&partCount=${totalParts}&mimeType=${encodeURIComponent(file.type)}`,
    {
      method: 'GET',
      headers: {
        "Content-Type": "application/json",
        "file-size": file.size.toString(),
        "x-token": authToken,
      },
      signal: controller.signal,
    },
    retryAttempts,
    retryDelay
  );

  if (!preSignedResponse.ok) {
    const errorData = await preSignedResponse.json().catch(() => ({}));
    throw new Error(`Failed to get pre-signed URL: ${errorData.message || preSignedResponse.statusText}`);
  }

  const pData: FileUploadResponse = await preSignedResponse.json();
  const preSignedData = pData?.data?.preSignedData;

  if (!preSignedData) {
    throw new Error('Invalid pre-signed URL response format');
  }

  const { uploadId, preSignedUrls, presignedUrl, location } = preSignedData;

  // Step 2: Upload file parts
  if (isMultipart) {
    return await handleMultipartUpload(
      file,
      fileIndex,
      totalFiles,
      uploadId,
      preSignedUrls,
      controller,
      completeUrl,
      authToken,
      chunkSize,
      retryAttempts,
      retryDelay,
      onProgress
    );
  } else {
    return await handleSinglePartUpload(
      file,
      fileIndex,
      totalFiles,
      presignedUrl || preSignedUrls?.[0]?.presignedUrl,
      location,
      controller,
      onProgress
    );
  }
};

const handleSinglePartUpload = async (
  file: File,
  fileIndex: number,
  totalFiles: number,
  presignedUrl: string,
  location: string | undefined,
  controller: AbortController,
  onProgress?: (progress: ProgressInfo) => void
): Promise<string> => {
  if (!presignedUrl) {
    throw new Error('No presigned URL provided for single part upload');
  }

  const response = await fetch(presignedUrl, {
    method: "PUT",
    body: file,
    headers: {
      "Content-Type": file.type || "application/octet-stream",
      "Content-Length": file.size.toString(),
    },
    signal: controller.signal,
  });

  if (!response.ok) {
    throw new Error(`Single part upload failed: ${response.statusText}`);
  }

  // Report completion
  onProgress?.({
    fileName: file.name,
    progress: 100,
    bytesUploaded: file.size,
    totalBytes: file.size,
    fileIndex: fileIndex + 1,
    totalFiles
  });

  if (!location) {
    throw new Error('No location provided for single part upload');
  }

  return spliceUploadedLocation(location);
};

const handleMultipartUpload = async (
  file: File,
  fileIndex: number,
  totalFiles: number,
  uploadId: string,
  preSignedUrls: Array<{ partNumber: number; presignedUrl: string }>,
  controller: AbortController,
  completeUrl: string,
  authToken: string,
  chunkSize: number,
  retryAttempts: number,
  retryDelay: number,
  onProgress?: (progress: ProgressInfo) => void
): Promise<string> => {
  if (!uploadId || !preSignedUrls || preSignedUrls.length === 0) {
    throw new Error('Invalid multipart upload data: missing uploadId or preSignedUrls');
  }

  const uploadedParts: UploadPart[] = [];
  let totalBytesUploaded = 0;

  // Upload each part
  for (let i = 0; i < preSignedUrls.length; i++) {
    if (controller.signal.aborted) {
      throw new Error('Upload cancelled by user');
    }

    const { partNumber, presignedUrl } = preSignedUrls[i];
    const start = i * chunkSize;
    const end = Math.min(start + chunkSize, file.size);
    const chunk = file.slice(start, end);

    try {
      const partResponse = await fetchWithRetry(
        presignedUrl,
        {
          method: "PUT",
          body: chunk,
          headers: {
            "Content-Type": "application/octet-stream",
            "Content-Length": chunk.size.toString(),
          },
          signal: controller.signal,
        },
        retryAttempts,
        retryDelay
      );

      if (!partResponse.ok) {
        throw new Error(`Part ${partNumber} upload failed: ${partResponse.statusText}`);
      }

      // Extract ETag from response headers (required for completion)
      // const etag = partResponse.headers.get('ETag');
      // if (!etag) {
      //   throw new Error(`Part ${partNumber} upload succeeded but no ETag received`);
      // }

      uploadedParts.push({
        partNumber
      });

      totalBytesUploaded += chunk.size;

      // Report progress
      const progress = Math.round((totalBytesUploaded / file.size) * 100);
      onProgress?.({
        fileName: file.name,
        progress,
        bytesUploaded: totalBytesUploaded,
        totalBytes: file.size,
        fileIndex: fileIndex + 1,
        totalFiles
      });

    } catch (error: any) {
      if (error.name === 'AbortError') {
        throw new Error('Upload cancelled by user');
      }
      throw new Error(`Failed to upload part ${partNumber}: ${error.message}`);
    }
  }

  // Step 3: Complete the multipart upload

  // Sort parts by part number to ensure correct order
  uploadedParts.sort((a, b) => a.partNumber - b.partNumber);

  const completeResponse = await fetchWithRetry(
    completeUrl,
    {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        "x-token": authToken,
      },
      body: JSON.stringify({
        fileName: file.name,
        uploadId: uploadId,
        //parts: uploadedParts // Include the uploaded parts with ETags
      }),
      signal: controller.signal,
    },
    retryAttempts,
    retryDelay
  );

  if (!completeResponse.ok) {
    const errorData = await completeResponse.json().catch(() => ({}));
    throw new Error(`Failed to complete multipart upload: ${errorData.message || completeResponse.statusText}`);
  }

  const completeData: CompleteUploadResponse = await completeResponse.json();

  if (!completeData.data?.location) {
    throw new Error('Invalid completion response format - no location received');
  }

  return spliceUploadedLocation(completeData.data.location);
};

/**
 * Main upload function - handles file validation and orchestrates the upload process
 * @param files - Single file or array of files to upload
 * @param module - Module name for the upload endpoint (default: "sales")
 * @param options - Optional upload configuration
 * @returns Promise<string[]> - Array of uploaded file locations
 */
export const uploadFiles = async (
  files: any,
  module = "sales",
  options: UploadOptions = {}
): Promise<string[]> => {
  if (Array.isArray(files) && files?.filter(i => i)?.length === 0) return [];
  try {
    let uFiles: string[] = [];
    const config = getApiConfig();
    const bUrl = config.s3BucketUrl;
    const bUrl2 = bUrl?.replace("https://", "");

    const controller = new AbortController();

    // Normalize input to array and filter valid files
    const iFiles = files ? (Array.isArray(files) ? files : [files]) : [];

    const existingFiles = iFiles.filter((file) => !(file instanceof File));
    if (iFiles && iFiles.length) {
      // Filter to ensure only File objects are processed
      const validFiles = iFiles.filter((file) => file instanceof File);

      if (validFiles && validFiles.length) {
        uFiles = await handleRegularUpload(validFiles, controller, module, options);
      } else {
        console.warn('⚠️ No valid File objects found in the provided input');
      }
    }

    return [...uFiles, ...existingFiles]?.map(f => f?.split(bUrl)?.join('')?.split(bUrl2)?.join(''))?.filter(Boolean) || [];
  } catch (error) {
    let errorMessage: string = "Something went wrong during file upload.";

    if (error instanceof Error) {
      errorMessage = error.message;
    }

    console.error('❌ Upload failed:', errorMessage);
    throw new Error(errorMessage);
  }
};

export const formatDateForPayload = (date: any) =>
  date && dayjs(date).isValid() ? dayjs(date).format("YYYY-MM-DD") : undefined;

export const formatTimeForPayload = (date: any) =>
  date && dayjs(date).isValid() ? dayjs(date).format("HH:mm:ss") : undefined;

export const formatDateTimeForPayload = (date: any) =>
  (date && dayjs(date).isValid()) ? dayjs(date).format("YYYY-MM-DD HH:mm:ss") : undefined;

export function isJSONString(str: string | undefined) {
  if (!str) return false;

  try {
    return JSON.parse(str);
  } catch (e) {
    return false;
  }
}

export const getErrorMessage = (error?: any) => {
  if (error instanceof Error) return error.message;
  else if (isJSONString(error)?.message) return isJSONString(error)?.message;
  else if (typeof error === 'string') return error;
  else return "Something went wrong";
};

export const InvoiceStatus = {
  Approved: "Approve",
  Rejected: "Reject",
};

/**
 * Get the default currency symbol from localStorage user data.
 * This is a utility function (not a hook) so it can be safely called anywhere.
 * @param currencyData - Optional pre-fetched currency data to avoid localStorage lookup
 */
export const defaultCurrencySymbol = (currencyData?: { symbol?: string }) => {
  if (currencyData?.symbol) {
    return currencyData.symbol;
  }
  try {
    const userData = JSON.parse(localStorage.getItem('_u_data') || '{}');
    return userData?.currency_data?.symbol || "";
  } catch {
    return "";
  }
};

export const getCurrencySymbol = (currencyData?: { symbol?: string, company_id?: number }) => {
  if (currencyData?.symbol) {
    return currencyData.symbol;
  }
  try {
    const userData = JSON.parse(localStorage.getItem('_u_data') || '{}');

    if (currencyData?.company_id && userData?.company_currencies) {
      const companyCurrency = userData.company_currencies[currencyData.company_id];
      if (companyCurrency?.symbol) {
        return companyCurrency.symbol;
      }
    }

    return userData?.currency_data?.symbol || "";
  } catch {
    return "";
  }
};


/**
 * Get the default currency format from localStorage user data.
 * This is a utility function (not a hook) so it can be safely called anywhere.
 * @param currencyData - Optional pre-fetched currency data to avoid localStorage lookup
 */
export const defaultCurrencyFormat = (currencyData?: { number_format?: string }) => {
  if (currencyData?.number_format) {
    return currencyData.number_format;
  }
  try {
    const userData = JSON.parse(localStorage.getItem('_u_data') || '{}');
    return userData?.currency_data?.number_format || "";
  } catch {
    return "";
  }
};

export const getCurrencyFormat = (currencyData?: { number_format?: string, company_id?: number }) => {
  if (currencyData?.number_format) {
    return currencyData.number_format;
  }
  try {
    const userData = JSON.parse(localStorage.getItem('_u_data') || '{}');

    if (currencyData?.company_id && userData?.company_currency_formats) {
      const companyCurrencyFormat = userData.company_currencies[currencyData.company_id]
      if (companyCurrencyFormat?.number_format) {
        return companyCurrencyFormat.number_format;
      }
    }

    return userData?.currency_data?.number_format || "";
  } catch {
    return "";
  }
};

/**
 * Get the default company from localStorage user data.
 * This is a utility function (not a hook) so it can be safely called anywhere.
 * @param userData - Optional pre-fetched user data to avoid localStorage lookup
 */
export const defaultCompany = (userData?: { accessCompanies?: number[]; company_id?: number | null }) => {
  let user = userData;
  if (!user) {
    try {
      user = JSON.parse(localStorage.getItem('_u_data') || '{}');
    } catch {
      return null;
    }
  }
  const accessCompanies = user?.accessCompanies || [];
  const defaultCompanyId = user?.company_id || null;

  let dcId = defaultCompanyId;

  if (Array.isArray(accessCompanies) && accessCompanies?.length > 0) {
    if (!accessCompanies?.includes(defaultCompanyId as number)) {
      dcId = accessCompanies?.[0];
    }
  }

  return dcId ? Number(dcId) : null;
};

export function omitDataKeys<T>(obj: T, extra?: Array<string>): T {
  // Default keys to omit
  const defaultOmitKeys = [
    "created_at",
    "updated_at",
    "created_by",
    "created_user",
    "updated_by",
    "updated_user",
    "is_deleted",
    "deleted_user",
    "deleted_by",
    "deleted_at",
    ...(extra ? extra : []),
  ];

  // Handle arrays separately without converting them to objects
  if (Array.isArray(obj)) {
    // Recursively process array elements
    return obj.map((item) => omitDataKeys(item, extra)) as unknown as T;
  }

  // Check if obj is an object
  if (_.isObject(obj) && !Array.isArray(obj)) {
    // Recursively apply omit on each property of the object
    return _.mapValues(
      _.omitBy(
        obj,
        (_, key) =>
          defaultOmitKeys.includes(key) ||
          key.endsWith("_data") ||
          key.endsWith("_status")
      ),
      (value) => {
        // Recurse on nested objects, excluding Day.js instances
        if (_.isObject(value) && !dayjs.isDayjs(value)) {
          return omitDataKeys(value, extra);
        }
        return value;
      }
    ) as T;
  }

  // If it's neither an object nor an array, return the value as is (e.g., strings, numbers)
  return obj;
}

// Define a type for the input objects in the array
export interface DataObject {
  [key: string]: any;
}

// Define a type for the processed object with label and value
export interface LabelValueObject extends DataObject {
  label: string;
  value: string | number | null;
}

/**
 * A global function to process an array of objects and return formatted label-value pairs.
 *
 * @param {Array<T>} dataArray - The array of objects to be processed.
 * @param {Array<T>} fallbackArray - The fallback array if dataArray is empty.
 * @param {Array<keyof T | string>} labelKeys - The keys to be concatenated for the label.
 * @param {keyof T | string} valueKey - The key to be used for the value.
 * @param {Function} [labelFormatter] - Optional custom formatter for label.
 * @returns {Array<LabelValueObject>} - The processed array of label-value objects.
 */
export const getLabelValuePairs = <T extends DataObject>(
  dataArray: T[],
  fallbackArray: T[],
  labelKeys: (keyof T | string)[],
  valueKey: keyof T | string,
  labelFormatter?: (item: T) => string
): LabelValueObject[] => {
  return (
    _.map(dataArray, (item: T) => {
      const label = labelFormatter
        ? labelFormatter(item)
        : _.compact(labelKeys.map((key) => _.get(item, key, ""))).filter(v => Boolean(v?.trim())).join(", ");

      return {
        ...item,
        label,
        value: _.get(item, valueKey, null),
      };
    }) || fallbackArray
  );
};
export function formatEmptyDataToNull<T>(obj: T): T {
  // Check if the input is an array and process each item recursively
  if (Array.isArray(obj)) {
    return obj.map((item) => formatEmptyDataToNull(item)) as unknown as T;
  }

  // If it's an object, iterate through the values and apply transformations
  if (_.isObject(obj)) {
    return _.mapValues(obj, (value, key) => {
      // Recursively handle nested objects or arrays
      if (
        Array.isArray(value)
      ) {
        return (value);
      }
      if (
        _.isObject(value) &&
        !dayjs.isDayjs(value) &&
        !(value instanceof File)
      ) {
        return formatEmptyDataToNull(value);
      }

      // Replace empty values (except 0) with null
      if (!value && value !== 0 && value !== false) {
        return null;
      }

      // Special handling for specific key patterns
      if (
        (key.includes("_id") && !key.includes("_ids")) ||
        key.includes("_amount")
      ) {
        // Convert values for '_id' or '_amount' keys to numbers
        return Array.isArray(value) ? value.map(Number) : Number(value);
      } else if (key.includes("date_time")) {
        // Format date fields
        return formatDateTimeForPayload(value);
      } else if (key.includes("date")) {
        // Format date fields
        return formatDateForPayload(value);
      } else if (key.includes("_time")) {
        // Format time fields
        return formatTimeForPayload(value);
      } else if (Array.isArray(value)) {
        // Ensure arrays are not replaced by null if they're empty
        return value.length ? value : [];
      }

      // Return the original value if no other transformation applies
      return value;
    }) as T;
  }

  // If it's neither an object nor an array, return the value as is
  return obj;
}

export function downloadFile(fileUrl: string, fileName = "") {
  if (!fileUrl || fileUrl === "") return;
  const a = document.createElement("a");
  a.target = "_blank";
  a.href = fileUrl;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}

//Download Doc
//eslint-disable-next-line
export const downloadDoc = async ({
  api,
  // fileName,
  raw
}: {
  api: string,
  fileName: string,
  raw: any
}) => {
  const headers = {
    "Content-Type": "application/json",
    ...getToken()
  };
  const config = getApiConfig();
  const response = await fetch(`${config.backendBaseUrl}/${api}`,
    {
      method: "POST",
      headers,
      body: raw,
      redirect: "follow",
    }
  );

  if (!response.ok) {
    throw new Error(await response.text());
  }
  const blob = await response.blob();
  const url = window.URL.createObjectURL(blob);
  window.open(url, '_blank');
  // Revoke the blob URL after some time to avoid memory leaks
  setTimeout(() => window.URL.revokeObjectURL(url), 1000);
  // const a = document.createElement("a");
  // a.href = url;
  // a.download = fileName;
  // document.body.appendChild(a);
  // a.click();
  // a.remove();
  // window.URL.revokeObjectURL(url);
}

export function formatResponseDatesToDayJS<T>(obj: T): T {
  // Check if the input is an array and process each item recursively
  if (Array.isArray(obj)) {
    return obj.map((item) => formatResponseDatesToDayJS(item)) as unknown as T;
  }

  if (_.isObject(obj)) {
    return _.mapValues(obj, (value, key) => {
      if (_.isObject(value) && !dayjs.isDayjs(value)) {
        return formatResponseDatesToDayJS(value);
      }

      if (key.includes("date") && value) {
        return dayjs(formatUtcDate(value, "YYYY-MM-DD HH:mm:ss"));
      }
      if (key.includes("_time") && value) {
        return dayjs(`${dayjs().format("YYYY-MM-DD")} ${value}`);
      }

      return value;
    }) as T;
  }

  // If it's neither an object nor an array, return the value as is
  return obj;
}

export const toFixedWithNumbers = (num: number, fraction?: number) => {
  let f = fraction ?? getDefaultFraction();
  let a = (num || num === 0) ? Number(num)?.toFixed(f) : num;
  return a;
}

export const findById = (arr: Array<any>, id: any) =>
  arr.find((a) => a.id == id);

export const getTaxAmountFromMultipleTaxCodes = (
  amount: number,
  taxCodes = [],
  detail = false
) => {
  if (!amount) return 0;

  let totalTaxAmount = 0;
  const taxCodeDetail = taxCodes?.map((code: any) => {
    const taxAmount = amount * (code.rate / 100);
    totalTaxAmount += taxAmount;

    return {
      id: code.id,
      name: code.name,
      rate: code.rate,
      tax_amount: taxAmount,
    };
  });

  if (detail) {
    return taxCodeDetail;
  }
  return totalTaxAmount;
};

export const getTaxAmountDataFromMultipleTaxCodes = (
  grossAmount: number,
  netAmount: number,
  taxCodes = [],
  detail = false
) => {
  let totalTaxAmount = 0;
  let totalTaxRate = 0;
  const taxCodeDetail = taxCodes.map((code: any) => {
    const taxBaseAmount =
      code.applies_to === "Gross" ? netAmount : grossAmount;
    // const taxAmount = grossAmount * (code.rate / 100);
    const taxAmount = taxBaseAmount * (code.rate / 100);
    totalTaxAmount += taxAmount;
    totalTaxRate += code.rate;

    return {
      id: code.id,
      name: code.name,
      rate: code.rate,
      tax_amount: taxAmount,
    };
  });

  if (detail) {
    return taxCodeDetail;
  }
  return {
    amount: totalTaxAmount,
    rate: totalTaxRate,
  };
};

export const calculateAmountData = (quantity: number, rate: number, discount_rate: number | null, discounted_items: any, taxCodes = [], treatRateAsPercentage = false) => {
  const amount = quantity * rate;
  let discountAmount = Number(discount_rate);
  if (discounted_items?.discount_category === "rate" || treatRateAsPercentage) {
    discountAmount = discount_rate ? amount * (discount_rate / 100) : 0;
  }
  let grossAmount = amount - discountAmount || 0;
  if (grossAmount < 0) {
    grossAmount = 0;
  }
  const taxData = getTaxAmountDataFromMultipleTaxCodes(
    grossAmount,
    amount,
    taxCodes
  );

  const taxAmount = taxData?.amount || 0;
  const taxRate = taxData?.rate || 0;

  const netAmount = grossAmount + Number(taxAmount) || 0;
  const totalAmount = grossAmount + Number(taxAmount) || 0;

  return { grossAmount, taxAmount, taxRate, discountAmount, netAmount, totalAmount }
}

export type AnyObject = Record<string, any>;

export const hasValue = (
  object: AnyObject,
  skipFields: string[] = []
): boolean => {
  const checkValue = (value: any, skipFields: string[]): boolean => {
    if (_.isArray(value)) {
      // If it's an array, recursively check its elements
      return _.some(value, (item) => checkValue(item, skipFields));
    }

    if (_.isPlainObject(value)) {
      // If it's an object, recursively check its keys and values
      return _.some(value, (val, key) => {
        if (skipFields.includes(key)) return false; // Skip specified fields
        return checkValue(val, skipFields);
      });
    }

    // Return true for any non-null, non-undefined, and non-empty value
    return !_.isNil(value) && !_.isEmpty(value);
  };

  return checkValue(object, skipFields);
};
export const formatAmountWithCurrency = (
  amount: number,
  currencySymbol?: string
): string => {
  if (!amount) {
    return `${currencySymbol ? currencySymbol : ""}`;
  }
  const defaultSymbol = defaultCurrencySymbol();
  const symbol = currencySymbol || defaultSymbol;

  return `${symbol} ${Number(amount).toFixed(2)}`;
};
export const formatAmountWithCurrencyData = (
  amount: number,
  currencySymbol?: string
): string => {
  if (!amount) {
    return "";
  }
  const symbol = currencySymbol || '';

  return `${symbol} ${Number(amount).toFixed(2)}`;
};

export type ManageItemsOptions = {
  key: string;
  action: "add" | "update" | "delete";
  value: any;
  items: any[];
  itemIndex: number
};

export const manageItems = ({
  key,
  action,
  value,
  items = [],
  itemIndex
}: ManageItemsOptions): any[] => {
  switch (action) {
    case "add": {
      // const existingItem = items?.find((item) => item[key] === value[key]);
      // if (existingItem) {
      //   // Update the existing item
      //   return items?.map((item) => (item[key] === value[key] ? value : item));
      // }
      // Add a new item
      return [...items, value];
    }

    case "update": {
      // Update an existing item
      return items.map((item, index) => ((itemIndex >= 0 ? itemIndex === index : item[key] === value[key]) ? value : item));
    }

    case "delete": {
      // Delete an item based on
      if (value?.index !== undefined) {
        return items.filter((_, index) => index !== value.index);
      }
      return items.filter((item) => item[key] !== value[key]);
    }

    default:
      console.warn(`Unsupported action type: ${action}`);
      return items;
  }
};

export function getPartyName(
  party: Record<any, any> | null | undefined
): string {
  if (!party) return "";

  const {
    name = "",
    first_name = "",
    middle_name = "",
    last_name = "",
    company_name = "",
  } = party;

  // Trim values and handle potential null values
  const trimmedName = name?.trim() || "";
  const trimmedFirstName = first_name?.trim() || "";
  const trimmedMiddleName = middle_name?.trim() || "";
  const trimmedLastName = last_name?.trim() || "";
  const trimmedCompanyName = company_name?.trim() || "";


  if (party?.account_type === 'Individual') {
    return [trimmedFirstName, trimmedMiddleName, trimmedLastName].filter(Boolean).join(' ');
  } else if (party?.account_type === 'Company') {
    return trimmedCompanyName
  } else {
    if (trimmedName) return trimmedName;
    if (trimmedFirstName) {
      return [trimmedFirstName, trimmedMiddleName, trimmedLastName].filter(Boolean).join(' ');
    }
    if (trimmedCompanyName) return trimmedCompanyName;
  }

  return "";
}

export const partyEmailIds = (json: any): string => {
  if (!json) return "";

  try {
    const parsed = JSON.parse(json);
    return Array.isArray(parsed) ? parsed.join(", ") : "";
  } catch {
    return json;
  }
};

export function formatResponseOnlyDatesToDayJS<T>(obj: T): T {
  // Check if the input is an array and process each item recursively
  if (Array.isArray(obj)) {
    return obj.map((item) => formatResponseDatesToDayJS(item)) as unknown as T;
  }

  if (_.isObject(obj)) {
    return _.mapValues(obj, (value, key) => {
      if (_.isObject(value) && !dayjs.isDayjs(value)) {
        return formatResponseDatesToDayJS(value);
      }

      if (key.includes("date") && value) {
        return dayjs(value);
      }

      return value;
    }) as T;
  }

  // If it's neither an object nor an array, return the value as is
  return obj;
}


/* fetch exchange & reverse rates */
export const fetchExchageRate = async (id: string, type: string = 'Buying') => {
  try {
    const response = await postV1CurrencyInfo({
      currancy_id: id,
      type: type,
      ...getToken()
    });

    const { exchange_rate = 1, reverse_rate = 1 } = response?.data || {};
    return { exchange_rate, reverse_rate };
  } catch (error) {
    return { exchange_rate: 1, reverse_rate: 1 };
  }
};


export const showSnackBar = (error: any) => {
  const message = getErrorMessage(error?.message)
  enqueueSnackbar(message, {
    variant: "error",
  });
}

export const fetchCompanyLocations = async (companyId: number) => {

  const res = await fetchApi(
    {
      apiKey: 'location',
      filters: {
        filters: { '&company_id.in': companyId }
      }
    });
  return res?.data || []
}

export const fetchItems = async (itemId: number, attributes?: string) => {

  const res = await fetchApi(
    {
      apiKey: 'items',
      filters: {
        filters: { '&id.in': itemId },
        select: attributes
      }
    });
  return res?.data || []
}


export const getOptionsData = async (key: string, id: number, select?: any, isArray = false) => {
  const res = await fetchApi(
    {
      apiKey: key,
      filters: {
        filters: { '&id.in': id },
        select
      }
    });
  return isArray ? res?.data : Array.isArray(res?.data) ? res?.data[0] : null;
}


export const fetchOptions = async (key: string, filters: any, select?: any, isArray = false) => {
  const res = await fetchApi(
    {
      apiKey: key,
      filters: {
        filters: filters,
        select
      }
    });
  return isArray ? res?.data : Array.isArray(res?.data) ? res?.data[0] : null;
}
export const createdOnAndBy = (data: any) => {
  const { created_at = '', created_user = {}, created_by_data = {} } = data || {}
  const { first_name = '', last_name = '' } = Object.keys(created_user)?.length ? created_user : created_by_data
  const fName = first_name?.trim() || '';
  const lName = last_name?.trim() || '';
  const cAt = created_at?.trim() || '';

  const text = `Created on ${formatDate(cAt, 'DD MMM, YYYY')}`

  if (!(fName || lName)) return text;

  return `${text} · ${formatText(`${fName} ${lName}`)}`
}

/**
 * Returns the full name of an object based on the provided keys.
 * The object is expected to have the keys as its properties.
 * If the object is empty, returns a default value.
 * @param {Record<string, any>} obj - The object to process
 * @param {string[]} keys - The keys to use for forming the name
 * @returns {string} The full name of the object
 */
export const getName = (obj: Record<string, any>, keys: string[]) => {
  if (_.isEmpty(obj)) {
    // If the object is empty, return a default value
    return "-";
  }

  // Map over the keys and get the corresponding values from the object
  // Filter out any values that are falsy or have no trimmed value
  // Join the remaining values with a space in between
  return keys
    .map((key) => obj?.[key])
    .filter((n) => Boolean(n && n?.trim()))
    .join(" ");
};

export const getToken = (token = null) => {
  const timezone = moment.tz.guess();
  const offsetMinutes = moment.tz.zone(timezone).utcOffset(Date.now());
  const requestToken = {
    "x-token": token ? token : localStorage.getItem(auth.storageTokenKeyName) || undefined,
    "x-timezone": offsetMinutes,
  };

  return requestToken;
};

export const checkForDuplicate = async (payload: any) => {
  try {
    const response = await postV1PartiesCheck({ ...getToken(), ...payload })
    return response?.data?.party_exists || false
  } catch (error) {
    throw new Error('An error occurred while checking for duplicates.')
  }
}

export const partyDuplicateCheck = async (
  activeTab: number | string,
  fValues: Record<string, any>,
  defaultValues?: Record<string, any>
): Promise<string | null> => {

  const values = { ...fValues };
  // Return early if activeTab is not 0 or required fields are not present
  if (activeTab !== 0 || !(values?.contact_no || values?.company_name)) {
    return null;
  }

  if (activeTab !== 0 || (!values?.contact_no && values?.company_name && values?.account_type !== 'Company')) {
    return null;
  }

  const rawNo = String(values?.contact_no || '').replace(/^\+/, '');
  let phoneNumber = parsePhoneNumberFromString(`+${rawNo}`);
  if (!phoneNumber?.nationalNumber && values?.country_code) {
    phoneNumber = parsePhoneNumberFromString(`${values.country_code}${rawNo}`);
  }
  values.contact_no = phoneNumber?.nationalNumber || values?.contact_no;
  values.country_code = phoneNumber?.countryCallingCode ? `+${phoneNumber.countryCallingCode}` : values?.country_code;

  // Determine if contact number or company name values have changed
  const normalizePhone = (contactNo: any, countryCode: any) => {
    const rNo = String(contactNo || '').replace(/^\+/, '');
    let p = parsePhoneNumberFromString(`+${rNo}`);
    if (!p?.nationalNumber && countryCode) {
      p = parsePhoneNumberFromString(`${countryCode}${rNo}`);
    }
    return {
      contact_no: p?.nationalNumber || String(contactNo || ''),
      country_code: p?.countryCallingCode ? `+${p.countryCallingCode}` : String(countryCode || ''),
    };
  };

  const normalizedDefault = normalizePhone(defaultValues?.contact_no, defaultValues?.country_code);
  const isDirtyPhone =
    !defaultValues ||
    normalizedDefault.contact_no !== values.contact_no ||
    normalizedDefault.country_code !== values.country_code;
  const isDirtyCompanyName =
    !defaultValues ||
    defaultValues?.company_name?.trim() !== values?.company_name?.trim();

  // If neither field has changed, no need to check for duplicates
  if (!isDirtyPhone && !isDirtyCompanyName) {
    return null;
  }

  // Parse phone number to extract country code and national number
  const countryCode = phoneNumber?.nationalNumber ? phoneNumber?.countryCallingCode
    ? `+${phoneNumber?.countryCallingCode}` : ''
    : values?.country_code;
  const contactNo = phoneNumber?.nationalNumber || values?.contact_no;

  // Construct payload for duplicate check
  const duplicateCheckPayload = {
    party: {
      account_type: values?.account_type, // "Individual" or "Company"
      ...(isDirtyPhone && countryCode ? { country_code: countryCode } : {}),
      ...(isDirtyPhone && contactNo ? { contact_no: contactNo } : {}),
      ...(values?.account_type === 'Company' && isDirtyCompanyName
        ? { company_name: values?.company_name }
        : {}),
    },
  };

  try {
    // Call API to check for duplicates
    const isDuplicate = await checkForDuplicate(duplicateCheckPayload);

    if (isDuplicate) {
      // Prepare and return an appropriate error message
      const duplicateType =
        values?.account_type === 'Company' ? phoneNumber?.nationalNumber ? 'company name or phone' : 'company name' : 'phone number';
      return `Added ${duplicateType} already exists. Please add a different ${duplicateType}.`;
    }
  } catch (error: any) {
    // Return error message in case of API failure
    return error.message || 'An error occurred while checking for duplicates.';
  }

  // Return null if no duplicates are found
  return null;
};

export const displayPhone = (data: Record<string, any>) => {
  const { contact_no = '', country_code = '' } = data || {}

  if (!contact_no) return ''

  if (country_code) {
    if (country_code?.includes("+")) {
      return `${country_code}${contact_no}`
    }
    return `+${country_code}${contact_no}`
  }

  return contact_no?.includes("+") ? contact_no : `+${contact_no}`
}

export const getPartyDependentData = async (
  id: number,
  options?: any
) => {
  let ad: any[] = [],
    co: any[] = [],
    cr = options?.currencies || [],
    cm = options?.companies || [],
    dsa = null,
    dba = null,
    pt = null,
    sp = null;

  const res = await getV1PartiesId({ id, ...getToken() });
  const p = res?.data?.parties?.party?.data || null;
  if (p) {
    const {
      payment_term = null,
      party_address_data = [],
      party_contact_data = [],
      currencies_data = [],
      companies_data = [],
      salesperson = null
    } = p;

    ad = party_address_data
    co = party_contact_data;
    cr = currencies_data;
    cm = companies_data;
    pt = payment_term;
    dsa = party_address_data?.find((addr: any) => Boolean(addr?.default_shipping_address));
    dba = party_address_data?.find((addr: any) => Boolean(addr?.default_billing_address));
    sp = salesperson
  }

  return {
    addresses: ad,
    contacts: co,
    currencies: cr,
    currencyIds: cr.map((c: any) => c.id),
    companies: cm,
    companyIds: cm.map((c: any) => c.id),
    paymentTerm: pt,
    defaultShipping: dsa,
    defaultBilling: dba,
    salesperson: sp
  };
};

export interface PayloadMapping {
  [key: string]: string | string[] | ((values: Record<string, any>) => any);
}

/**
 * Maps API payload by transforming values based on the provided mapping configuration.
 * 
 * @param {PayloadMapping} payloadMapping - An object defining the mapping configuration.
 * @param {Record<string, any>} values - The source values to be transformed.
 * @returns {Record<string, any>} The transformed payload object.
 */
const isEmptyValue = (value: any): boolean => {
  return _.isNil(value) || value === '' || (_.isObject(value) && _.isEmpty(value));
};

export const mapApiPayload = (payloadMapping: PayloadMapping, values: Record<string, any>): Record<string, any> => {
  return _.mapValues(payloadMapping, (val) => {
    // If the mapping value is a function, execute it with the values as the argument
    if (_.isFunction(val)) {
      return (val as (values: Record<string, any>) => any)(values);
    }
    // If the mapping value is an array, map each element to its corresponding value in the source
    if (_.isArray(val)) {
      return (val as string[]).map((key) => _.get(values, key, null));
    }
    // If the mapping value is an object (excluding Day.js), recursively process it
    if (_.isObject(val) && !_.isFunction(val) && !dayjs.isDayjs(val)) {
      return mapApiPayload(val as PayloadMapping, values);
    }
    // Directly map a single key to its value in the source
    const result = _.get(values, val, null)
    return isEmptyValue(result) ? null : result
  });
};

export const mapAsyncApiPayload = async (payloadMapping: PayloadMapping, values: Record<string, any>): Promise<Record<string, any>> => {
  const entries = Object.entries(payloadMapping).map(async ([key, val]) => {
    if (_.isFunction(val)) {
      return [key, await val(values)];
    }
    if (_.isArray(val)) {
      const resolvedArray = await Promise.all(val.map(async (key) => _.get(values, key, null)));
      return [key, resolvedArray];
    }
    if (_.isObject(val) && !_.isFunction(val) && !dayjs.isDayjs(val)) {
      return [key, await mapAsyncApiPayload(val as PayloadMapping, values)];
    }
    return [key, _.get(values, val, null)];
  });

  return Object.fromEntries(await Promise.all(entries));
};


export const isBetweenTheDates = (startDate: any, endDate: any) => {
  if (!startDate || !endDate) return false;
  const start = dayjs(startDate).startOf('day');
  const end = dayjs(endDate).endOf('day');
  const currentDate = dayjs();
  return currentDate.isAfter(start) && currentDate.isBefore(end) || currentDate.isSame(start) || currentDate.isSame(end);
};

export const setRateBasedOnPriceRules = (salesPrice: any, priceRules: any, addedQuantity: any) => {
  let updatedRate = salesPrice
  if (priceRules?.length) {
    const sortedPriceRules = _.orderBy(
      priceRules,
      ['minimum_quantity'],
      ['desc']
    );
    for (const pRules of sortedPriceRules) {
      if (Number(addedQuantity) >= Number(pRules?.minimum_quantity)) {
        if (isBetweenTheDates(pRules?.start_date, pRules?.end_date)) {
          updatedRate = Number(pRules?.unit_price) || undefined;
          break;
        }
      }
    }
  }
  return updatedRate
};


export const uploadAttachments = async (files: any) => {
  let existingAttachments =
    files?.filter((i: File | string) => !(i instanceof File)) || [];
  const newFiles = files?.filter((i: File | string) => i instanceof File) || [];
  const config = getApiConfig();
  const bUrl = config.s3BucketUrl;
  existingAttachments = existingAttachments.map((ea: string) =>
    ea.replace(bUrl, "")
  );

  let uplaodedAttachments: string[] = [];

  if (newFiles.length) {
    uplaodedAttachments = await uploadFiles(newFiles, "sales");
  }

  uplaodedAttachments = [...uplaodedAttachments, ...existingAttachments];
  if (Array.isArray(uplaodedAttachments) && uplaodedAttachments?.length) {
    return uplaodedAttachments.join(",");
  }
  return null;
};

export const addOrEditArray = (array: any[] = [], data: any) => {
  const { itemIndex, ...updatedData } = data;

  const newArray = [...array];

  if (newArray[itemIndex]) {
    newArray[itemIndex] = { ...updatedData };
    return newArray;
  }

  return [...newArray, updatedData];
};

export const getDefaultUserData = () => {
  const uData = localStorage.getItem("_u_data");
  const userData = uData ? JSON.parse(uData) : {};
  return userData;
}

export const getDefaultFraction = (): number => {
  const userData = getDefaultUserData();
  const currencyData = userData?.currency_data;

  // Check if the current module has a custom fraction field mapping
  // (e.g. { accounting: 'accounting_fraction_unit' })
  try {
    const mapRaw = localStorage.getItem('_module_fraction_map');
    if (mapRaw && currencyData) {
      const map: Record<string, string> = JSON.parse(mapRaw);
      const pathname = window.location.pathname;
      for (const moduleName of Object.keys(map)) {
        if (pathname.includes(`/dashboard/${moduleName}`)) {
          const fieldName = map[moduleName];
          const value = currencyData[fieldName];
          if (value != null) {
            return Number(value);
          }
          break;
        }
      }
    }
  } catch {
    // Ignore parse errors; fall through to default
  }

  const fractionUnit = currencyData?.fraction_unit;
  return Number(fractionUnit ?? 2);
};

export const getAccessibleModules = (moduleNames: string[] = []): string[] => {
  const userData = getDefaultUserData();
  const accessModules = userData?.module_access || [];

  const findSubModules = accessModules
    .filter(module => moduleNames.includes(module.module_name))
    .map(module => ({
      ...module,
      sub_modules: [...(module.sub_modules || []), { sub_module_name: "dashboard" }],
    }));

  const subModuleNamesSet = new Set(
    findSubModules.flatMap(module => module.sub_modules.map(subModule => subModule.sub_module_name))
  );

  const permission = JSON.parse(localStorage.getItem("role-permission") || "{}");
  return Array.from(subModuleNamesSet).filter(subModule =>
    Object.keys(permission).some(key => key.startsWith(subModule.split("/").pop()))
  ) as string[];
};

export const filterAccessibleModules = (menu: any, moduleNames: string[] = []) => {
  const accessibleMenus = new Set(getAccessibleModules(moduleNames))


  return menu.reduce((filtered, item) => {
    const isSubModuleValid = item.bacSubModuleName && accessibleMenus.has(item.bacSubModuleName);
    const filteredSubmenu = item.submenu?.length ? filterAccessibleModules(item.submenu, moduleNames) : [];

    if (isSubModuleValid || filteredSubmenu.length) {
      filtered.push({ ...item, submenu: filteredSubmenu });
    }
    return filtered;
  }, []);
}

// Usage example:
// const accessibleModules = getAccessibleModules(["manufacturing", "inventory", "sales"]);


export const checkDuplicateTracking = (data: any, typeOfTrcebility: string, trackRows: any[]) => {

  let isDuplicate = false
  let errorMsg = null
  // Check for duplicate tracking numbers
  const isSerialTracking = typeOfTrcebility === 'Serial Number Tracking';
  const trackingField = isSerialTracking ? 'serial_number' : 'lot_number';
  const inputValue = isSerialTracking
    ? data?.add_stock_transfer?.lot_number?.serial_number
    : data?.add_stock_transfer?.lot_number?.lot_number;
  errorMsg = isSerialTracking
    ? "This serial Number is already available"
    : "This lot Number is already available";

  if (trackRows[data?.itemIndex]?.[trackingField] == inputValue) {
    return { isDuplicate: false }
  }
  if (['Serial Number Tracking', 'Lot Tracking'].includes(typeOfTrcebility)) {
    isDuplicate = trackRows.some((o) =>
      o?.[trackingField] === inputValue
    );
  }
  return {
    isDuplicate,
    errorMsg
  }
}
export function getNestedValue(obj: any, path: any) {
  return path.split('.').reduce((acc: any, key: any) => (acc && acc[key] !== undefined ? acc[key] : undefined), obj);
}

// export const calculatePeriods = (startDateTime: Date, endDateTime: Date) => {
//     const start = dayjs(startDateTime);
//     const end = dayjs(endDateTime);

//     if (end.isBefore(start)) {
//         return null;
//     }

//     const totalMinutes = end.diff(start, 'minute');
//     if (totalMinutes < 0) {
//         return null;
//     }

//     let current = dayjs(start);
//     let years = 0;
//     let months = 0;
//     let days = 0;
//     let hours = 0;
//     // let minutes = 0;

//     // Calculate years
//     while (current.add(1, 'year').isBefore(end) || current.add(1, 'year').isSame(end)) {
//         years++;
//         current = current.add(1, 'year');
//     }

//     // Calculate months
//     while (current.add(1, 'month').isBefore(end) || current.add(1, 'month').isSame(end)) {
//         months++;
//         current = current.add(1, 'month');
//     }

//     // Calculate days  
//     while (current.add(1, 'day').isBefore(end) || current.add(1, 'day').isSame(end)) {
//         days++;
//         current = current.add(1, 'day');
//     }

//     // Calculate hours
//     while (current.add(1, 'hour').isBefore(end) || current.add(1, 'hour').isSame(end)) {
//         hours++;
//         current = current.add(1, 'hour');
//     }

//     // Calculate remaining minutes
//     // minutes = end.diff(current, 'minute');

//     const parts = [];

//     if (years > 0) {
//         parts.push(`${years} ${years === 1 ? 'Year' : 'Years'}`);
//     }
//     if (months > 0) {
//         parts.push(`${months} ${months === 1 ? 'Month' : 'Months'}`);
//     }
//     if (days > 0) {
//         parts.push(`${days} ${days === 1 ? 'Day' : 'Days'}`);
//     }
//     if (hours > 0) {
//         parts.push(`${hours} ${hours === 1 ? 'Hour' : 'Hours'}`);
//     }
//     // if (minutes > 0) {
//     //     parts.push(`${minutes} ${minutes === 1 ? 'Minute' : 'Minutes'}`);
//     // }

//     if (parts.length === 0) {
//         return '0 Minutes';
//     }

//     return parts.join(' ');
// };
//eslint-disable-next-line
export const calculatePeriods = (
  startDateTime: Date,
  endDateTime: Date,
  mode: 'Day' | 'Week' | 'Month' | 'Calendar Month' | 'Year' | 'Hour' = 'Month'
) => {
  const start = dayjs(startDateTime);
  const end = dayjs(endDateTime);

  if (end.isBefore(start)) {
    return null;
  }

  switch (mode) {
    case 'Year': {
      const years = end.diff(start, 'year');
      const remainingMonths = end.diff(start.add(years, 'year'), 'month');
      return `${years} ${years === 1 ? 'Year' : 'Years'}${remainingMonths > 0 ? `, ${remainingMonths} ${remainingMonths === 1 ? 'Month' : 'Months'}` : ''}`;
    }

    case 'Month':
    case 'Calendar Month': {
      const months = end.diff(start, 'month');
      const remainingDays = end.diff(start.add(months, 'month'), 'day');
      return `${months} ${months === 1 ? 'Month' : 'Months'}${remainingDays > 0 ? `, ${remainingDays} ${remainingDays === 1 ? 'Day' : 'Days'}` : ''}`;
    }

    case 'Week': {
      const weeks = end.diff(start, 'week');
      const remainingDaysWeekly = end.diff(start.add(weeks, 'week'), 'day');
      return `${weeks} ${weeks === 1 ? 'Week' : 'Weeks'}${remainingDaysWeekly > 0 ? `, ${remainingDaysWeekly} ${remainingDaysWeekly === 1 ? 'Day' : 'Days'}` : ''}`;
    }

    case 'Day': {
      const totalHours = end.diff(start, 'hour');
      const days = Math.floor(totalHours / 24);
      const remainingHours = totalHours % 24;

      if (remainingHours > 0) {
        return `${days + 1} ${days + 1 === 1 ? 'Day' : 'Days'}`;
      }
      return `${days} ${days === 1 ? 'Day' : 'Days'}`;
    }

    case 'Hour': {
      const hours = end.diff(start, 'hour');
      return `${hours} ${hours === 1 ? 'Hour' : 'Hours'}`;
    }

    default:
      return 'Invalid mode';
  }
};
export const removeIdFromObject = (array: any) => array?.map(i => ({
  ...i,
  id: undefined
}))

export const fetchRentalResponseItems = async (filters: string) => {
  //eslint-disable-next-line
  try {
    const response = await getV1CrossHireRfqResponseItems({
      filters,
      ...getToken(),
    });

    return response?.data?.rfq_response_items ?? [];
  } catch (error) {
    throw error;
  }
};
export const fetchRfqItemsByIdForResponse = async (filters: string) => {
  //eslint-disable-next-line
  try {
    const response = await getV1RfqResponseItems({
      filters,
      ...getToken(),
    });

    return response?.data?.rfq_response_items ?? [];
  } catch (error) {
    throw error;
  }
};

export const appendConditionSafely = (original: string | undefined, newCondition: string): string => {
  const cleanConditionString = (str: string): string => {
    // Remove leading special chars except '('
    return str.trim().replace(/^([^\w(]+)/, '');
  };

  const extractConditions = (str: string): string[] => {
    // Remove outermost brackets if they exist, then split by '&' or ','
    return str
      .trim()
      .replace(/^[(]|[)]$/g, '')
      .split(/[&,]/)
      .map((cond) => cond.trim())
      .filter(Boolean);
  };

  // If no original, clean newCondition and wrap in ()
  if (!original || typeof original !== 'string' || original.trim() === '') {
    const cleaned = cleanConditionString(newCondition);
    return `(${cleaned})`;
  }

  // Extract existing and new conditions
  const existingConditions = new Set<string>(extractConditions(original));
  const incomingConditions = extractConditions(newCondition);

  // Filter out duplicates
  const filteredNew = incomingConditions.filter(
    (cond) => !existingConditions.has(cond)
  );

  // Combine both
  const allConditions = [...existingConditions, ...filteredNew];
  return `(${allConditions.join('&')})`;
};


export const fetchAssemblyItemData = async (itemId: number) => {
  const response = await getV1AssemblyItemsId({
    id: itemId,
    ...getToken()
  });
  return response?.data?.data || null;
};
export const getFileName = (file) => {
  if (!file) return ""
  if (file instanceof File) {
    return file.name
  } else if (typeof file === 'string') {
    const parts = file?.split('/');
    return parts?.[parts?.length - 1];
  } else if (Array.isArray(file) && file?.length > 0) {
    return file.map(f => {
      if (f instanceof File) {
        return f.name
      }
      const parts = f?.split('/');
      return parts?.[parts?.length - 1];
    }).join(', ')
  }
}

export const getFieldFilters = (fields: any[], fieldNames: string | string[]) => {
  if (!fields?.length) return Array.isArray(fieldNames) ? new Map() : {};
  const filters = new Map()
  if (Array.isArray(fieldNames) && fieldNames?.length) {
    fieldNames.forEach(f => {
      const filt = fields.find(fi => fi.name === f)?.field_properties?.customeFilter || {}
      filters.set(f, filt)
    })
    return filters
  }
  return fields.find(fi => fi.name === fieldNames)?.field_properties?.customeFilter || {}
};

export const getNextScheduleDate = (currentDate: any, billingCycle: any) => {
  switch (billingCycle?.duration) {
    case 'Hour':
      return dayjs(currentDate).add(1, 'hour');
    case 'Day':
      return dayjs(currentDate).add(1, 'day');
    case 'Week':
      return dayjs(currentDate).add(1, 'week');
    case '2 Week':
      return dayjs(currentDate).add(2, 'week');
    case 'Month':
      // "Month" means actual 1 month (30 days)
      return dayjs(currentDate).add(30, 'day');
    case 'Calendar Month':
      // "Calendar Month" means end of the month
      return dayjs(currentDate).endOf('month').add(1, 'day').startOf('day');
    case 'Quarter':
    case '3 Month':
      return dayjs(currentDate).add(3, 'month');
    case '6 Month':
      return dayjs(currentDate).add(6, 'month');
    case 'Year':
    case '1 Year':
      return dayjs(currentDate).add(1, 'year');
    case '3 Year':
      return dayjs(currentDate).add(3, 'year');
    case '5 Year':
    case '5Year':
      return dayjs(currentDate).add(5, 'year');
    default:
      return dayjs(currentDate).add(1, 'month');
  }
};
//eslint-disable-next-line
export const getCountryIdByName = async (name: string) => {
  const response = await getV1LocationsCountries({
    filters: `(name.like=%${name}%)`,
    ...getToken(),
  });
  return response?.data?.countries?.[0]?.id || null;

}
export const getSlicedValue = (value: string, length: number): string => {
  if (!value) return '';
  return value.slice(0, length);
};

export const skuGenerator = ({
  name,
  category,
  sequence = '0001'
}: {
  name: string;
  category: string;
  sequence?: string;
}): string => {
  const cleanCategory = category.replace(/[^a-zA-Z0-9]/g, '');
  const cleanName = name.replace(/[^a-zA-Z0-9]/g, '');

  const categoryPart = getSlicedValue(cleanCategory, 3).toUpperCase();
  const namePart = getSlicedValue(cleanName, 3).toUpperCase();

  return `${categoryPart}-${namePart}-${sequence}`;
};

export const checkSkuAndItemName = async (payload: any) => {
  const response = await postV1InventoryItemsCheck({
    ...payload,
    ...getToken(),
  });
  return response?.data?.item_exists || null;
}

export const checkUniqueFields = async (payload: any) => {
  const apiPayload = {
    ...payload,
    ...(payload.name && {
      company_name: payload.name,
    }),
    ...getToken(),
  }
  delete apiPayload.name
  const response = await postV1LeadCheck(apiPayload)
  const itemExists = response?.data?.item_exists || {}
  const { name, ...rest } = itemExists

  return {
    ...rest,
    company_name: name,
  }
}

export interface FormValues {
  [key: string]: any;
}

/**
 * Helper function to process field disabling logic
 */
const processFieldDisabling = (
  currentFieldValue: any,
  valueConfig: any,
  fieldsToDisableSet: Set<string>
): void => {
  if (currentFieldValue !== null && currentFieldValue !== undefined) {
    // Convert current value to string for consistent comparison
    const valueKey = String(currentFieldValue);

    // Check for exact match first
    if (valueConfig[valueKey]) {
      valueConfig[valueKey].forEach((fieldName: string) => {
        fieldsToDisableSet.add(fieldName);
      });
    }
    // Check for type-specific matches (boolean, number)
    else if (typeof currentFieldValue === 'boolean' && valueConfig[currentFieldValue]) {
      valueConfig[currentFieldValue].forEach((fieldName: string) => {
        fieldsToDisableSet.add(fieldName);
      });
    }
    else if (typeof currentFieldValue === 'number' && valueConfig[currentFieldValue]) {
      valueConfig[currentFieldValue].forEach((fieldName: string) => {
        fieldsToDisableSet.add(fieldName);
      });
    }
  } else if (valueConfig?.['NO_VALUE']) {
    // Handle NO_VALUE case when field is empty/null/undefined
    valueConfig['NO_VALUE'].forEach((fieldName: string) => {
      fieldsToDisableSet.add(fieldName);
    });
  }
};

// Types for the configuration object
export interface UpdateFieldsDisabledConfig {
  data: any[];
  materialCostingType: string;
  formValues: FormValues;
  fieldsConfig?: FieldDisableConfig;
  isEditMode?: boolean;
  isAddMode?: boolean;
  alwaysDisabledFields?: string[];
  editModeDisabledFields?: string[];
  addModeDisabledFields?: string[];
  customDisabledFields?: string[];
}

export const updateFieldsDisabledState = ({
  data,
  materialCostingType,
  formValues,
  fieldsConfig = INVENTORY_FIELDS_TO_BE_DISABLED,
  isEditMode = false,
  isAddMode = false,
  alwaysDisabledFields = INVENTORY_ALWAYS_DISABLED_FIELDS,
  editModeDisabledFields = INVENTORY_EDIT_MODE_DISABLED_FIELDS,
  addModeDisabledFields = INVENTORY_ADD_MODE_DISABLED_FIELDS,
  customDisabledFields = []
}: UpdateFieldsDisabledConfig): any[] => {
  // Create a set to track all fields that should be disabled conditionally
  const conditionallyDisabledFields = new Set<string>();

  // Get all field names for the current material type (for material-specific fields)
  const materialTypeFieldNames = new Set(
    data
      ?.filter(field => field?.field_properties?.type === materialCostingType)
      ?.map(field => field?.name) || []
  );

  // Get all field names in the form (for global fields)
  const allFieldNames = new Set(data?.map(field => field?.name) || []);

  // Process each configuration entry for conditional disabling
  Object.entries(fieldsConfig).forEach(([configKey, valueConfig]) => {
    if (configKey === materialCostingType) {
      // Material-specific configuration (like pipe_costing)
      Object.entries(valueConfig).forEach(([dependentFieldName, nestedValueConfig]) => {
        if (materialTypeFieldNames.has(dependentFieldName)) {
          const fieldValue = formValues?.[dependentFieldName];
          processFieldDisabling(fieldValue, nestedValueConfig, conditionallyDisabledFields);
        }
      });
    } else if (allFieldNames.has(configKey)) {
      // Global field configuration (like is_rental)
      const currentFieldValue = formValues?.[configKey];
      processFieldDisabling(currentFieldValue, valueConfig, conditionallyDisabledFields);
    }
  });

  // Update form fields with disabled state
  return data.map(field => {
    // Check different types of disabled states
    const isAlwaysDisabled = alwaysDisabledFields.includes(field.name);
    const isEditModeDisabled = isEditMode && editModeDisabledFields.includes(field.name);
    const isAddModeDisabled = isAddMode && addModeDisabledFields.includes(field.name);
    const isConditionallyDisabled = conditionallyDisabledFields.has(field.name);
    const isCustomDisabled = customDisabledFields.includes(field.name);
    // const hasOriginalDisabled = field.disabled === true; // Only respect explicit true values

    // Field is disabled if any condition is met
    const isDisabled = isAlwaysDisabled || isEditModeDisabled || isAddModeDisabled || isConditionallyDisabled || isCustomDisabled;

    return {
      ...field,
      disabled: isDisabled,
      disableTableAddButton: isDisabled,
      disableDefaultActionColumn: isDisabled || Boolean(field?.disableDefaultActionColumn)
    };
  });
};

export const remainingMaterialCostingTypes = (type: string | string[]) => {
  const types = Array.isArray(type) ? type : [type]

  return INVENTORY_MATERIAL_COSTING_TYPE_ARR.filter(
    mct => !types.includes(mct)
  )
}
export const matchedMaterialCostingTypeLabel = (type: string | string[]) => {
  const types = Array.isArray(type) ? type : [type]

  return INVENTORY_MATERIAL_COSTING_TYPE_OPTIONS.find(o =>
    types.includes(o.value)
  )?.label || null
}

export const fetchDataLocally = (params: any, arr: any) => {
  const { search = '', limit = 25, skip = 0 } = params;

  // Filter entityFields based on search term
  let filteredData = arr || [];
  if (search && search.length > 0) {
    const searchLower = search.toLowerCase();
    filteredData = filteredData.filter((item: any) => {
      const label = item?.label || item?.name || '';
      return label.toLowerCase().includes(searchLower);
    });
  }

  const totalCount = filteredData.length;

  const paginatedData = filteredData.slice(skip, skip + limit).map((item: any) => ({
    ...item,
    label: item?.label || item?.name,
    value: item?.value || item?.id || item?.name
  }));

  return {
    data: paginatedData,
    pagination: {
      totalCount
    }
  };
}
